// extracted by mini-css-extract-plugin
export default {"lds-heart":"style_lds-heart__qkUXh","div-after":"style_div-after__H0VWB","div-before":"style_div-before__XX3d0"};